import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { Maestro_Provincias } from '../../models/generic/Maestro_Provincias';
import { Maestros_CiudadesService } from '../../services/maestros_ciudades';
import { Maestros_ProvinciasService } from '../../services/maestros_provincias';
import { Maestro_Provincias_Actualizacion } from '../../models/generic/Maestro_Provincias_Actualizacion';
import { Maestro_Ciudades } from 'src/app/models/generic/Maestro_Ciudades';
import { Listas } from 'src/app/models/generic/Listas';

@Component({
  selector: 'maestros-provincias-editar',
  templateUrl: './maestros-provincias-editar.component.html',
  styleUrls: ['./maestros-provincias-editar.component.scss']
})
export class MaestrosProvinciasEditarComponent implements OnInit{
  
  form: FormGroup;
  formFiltro: FormGroup;
  tituloForma: string = 'Registro de provincias';
  tituloBoton: string = 'Registrar provincias';
  mostrarCargando: boolean = false;
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  idTabSeleccionado: number = 0;
  COLOR_COBERTURA: string = '#88FF98';
  COLOR_NOCOBERTURA: string = '#F2B5C6';

  detalleSeleccionado: number;
  formCiudades: FormGroup;
  editarRegistroCiudad: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSourceCiudades: MatTableDataSource<Maestro_Ciudades>;
  columnasEncabezadoCiudad: string[] = ['codigo', 'descripcion', 'cobertura', 'acciones'];
  listaDatosCiudades: Maestro_Ciudades[] = [];
  listaDatosCiudadesEliminar: Maestro_Ciudades[] = [];
  parametrosPrincipal: Maestro_Provincias;
  listaColoresPoligono: Listas[] = [];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_ProvinciasService,
    public datosServicesCiudades: Maestros_CiudadesService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.LlenarListaPoligonos();
    
    this.listaDatosCiudadesEliminar = [];
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de provincias';
      this.tituloBoton = 'Editar provincia';
    } else {
      this.tituloForma = 'Registro de provincias';
      this.tituloBoton = 'Registrar provincia';
      this.parametrosPrincipal = new Maestro_Provincias();
      this.parametrosPrincipal.codigo = '';
      
      this.recargarListaCiudades();
    }
    this.ConsultarRegistrosCiudades();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      codigo: ['', [Validators.required, Validators.maxLength(3)]],
      descripcion: ['', [Validators.required, Validators.maxLength(100)]],
      nombreMapa: ['', [Validators.maxLength(100)]]
    });

    this.formFiltro = this.fb.group({
      filtro: ['']
    });

    this.IniciarFormularioCiudades();
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosProvinciasComponent');
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else {
        this.EliminarRegistroCiudad();
      }
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;
    
    let parametrosActualizacion: Maestro_Provincias_Actualizacion = new Maestro_Provincias_Actualizacion();
    parametrosActualizacion.principal = new Maestro_Provincias();
    parametrosActualizacion.principal.codigo = this.form.get('codigo').value;
    parametrosActualizacion.principal.descripcion = this.form.get('descripcion').value;
    parametrosActualizacion.principal.nombreMapa = this.form.get('nombreMapa').value;
    parametrosActualizacion.listaCiudades = this.listaDatosCiudades;
    parametrosActualizacion.listaCiudadesEliminar = this.listaDatosCiudadesEliminar;

    this.datosServices.Actualizar(parametrosActualizacion)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosProvinciasComponent');
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarRegistrosCiudades() {
    this.mostrarCargando = true;
    this.datosServicesCiudades.ConsultarXProvincia(this.parametrosPrincipal.codigo, this.formFiltro.value)
              .subscribe((resp: Maestro_Ciudades[]) =>{
                this.mostrarCargando = false;
                this.listaDatosCiudades = resp;
                this.recargarListaCiudades();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  tabSeleccionado(item: any) {
    this.idTabSeleccionado = item.index;    
  }

  IniciarFormularioCiudades() {
    this.formCiudades = this.fb.group({
      id: [0],
      codigo: ['', [Validators.required, Validators.maxLength(5)]],
      descripcion: ['', [Validators.required, Validators.maxLength(100)]],
      provincia: [''],
      descripcionProvincia: [''],
      colorPoligono: [''],
      nombreMapa: ['', [Validators.maxLength(100)]]
    });
  }
  recargarListaCiudades() {
    this.dataSourceCiudades = new MatTableDataSource(this.listaDatosCiudades);
    this.dataSourceCiudades.paginator = this.paginator;
    this.dataSourceCiudades.sort = this.sort;
  }
  NuevaCiudad() {
    this.editarRegistroCiudad = true;
    this.IniciarFormularioCiudades();
    this.formCiudades.get('id').setValue((this.listaDatosCiudades.length + 1) * -1);
  }
  EditarCiudad(ciudadEditar: Maestro_Ciudades) {
    this.editarRegistroCiudad = true;
    this.formCiudades.setValue(ciudadEditar);
  }
  EliminarCiudad(ciudadEditar: Maestro_Ciudades) {
    this.detalleSeleccionado = ciudadEditar.id;
    this.codigoAccion = 'eliminarCiudad';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarCiudad() {
    if (this.formCiudades.valid) {
      this.editarRegistroCiudad = false;
      this.formCiudades.get('provincia').setValue(this.form.get('codigo').value);
      if (this.listaDatosCiudades.filter(x => x.id === this.formCiudades.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosCiudades.filter(x => x.id === this.formCiudades.get('id').value)[0];
        parametroActualizar.codigo = this.formCiudades.get('codigo').value;
        parametroActualizar.descripcion = this.formCiudades.get('descripcion').value;
        parametroActualizar.descripcionProvincia = this.formCiudades.get('descripcionProvincia').value;
        parametroActualizar.provincia = this.formCiudades.get('provincia').value;
        parametroActualizar.colorPoligono = this.formCiudades.get('colorPoligono').value;
        parametroActualizar.nombreMapa = this.formCiudades.get('nombreMapa').value;
      } else {
        this.listaDatosCiudades.push(this.formCiudades.value);
      }
      
      this.recargarListaCiudades();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formCiudades);
    }
  }
  CancelarEditarCiudad() {
    this.editarRegistroCiudad = false;
  }
  EliminarRegistroCiudad() {
    if (this.detalleSeleccionado > 0) {
      this.listaDatosCiudadesEliminar.push(this.listaDatosCiudades.filter(x => x.id === this.detalleSeleccionado)[0]);
    }
    let listaNueva: Maestro_Ciudades[] = [];
    for (let index = 0; index < this.listaDatosCiudades.length; index++) {
      if (this.listaDatosCiudades[index].id !== this.detalleSeleccionado) {
        listaNueva.push(this.listaDatosCiudades[index]);
      }
    }
    this.listaDatosCiudades = listaNueva;
    this.recargarListaCiudades();
  }
  LlenarListaPoligonos() {
    let itemColorCobertura: Listas = new Listas();
    itemColorCobertura.codigo = 'VERDE';
    itemColorCobertura.descripcion = 'Zona de prestación del servicio';

    let itemColorNoCobertura: Listas = new Listas();
    itemColorNoCobertura.codigo = 'ROJO';
    itemColorNoCobertura.descripcion = 'Zona de operación de reembolso';

    this.listaColoresPoligono.push(itemColorCobertura);
    this.listaColoresPoligono.push(itemColorNoCobertura);
  }
  DescripcionCobertura(itemSeleccionado: Maestro_Ciudades): string {
    return itemSeleccionado.colorPoligono === 'VERDE' ? 'Zona de prestación del servicio' : 'Zona de operación de reembolso';
  }
  ColorCobertura(itemSeleccionado: Maestro_Ciudades): string {
    return itemSeleccionado.colorPoligono === 'VERDE' ? this.COLOR_COBERTURA : this.COLOR_NOCOBERTURA;
  }
}
